module.exports = __webpack_public_path__ + "static/media/performance.59267381.png";